import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import { alpha, styled } from "@mui/material/styles";
import { ReactComponent as SearchCross } from "assets/cross_search.svg";
import { setSearchActive, setSearchText } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import React, { useContext } from "react";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { minSearchStrLength } from "utils/CommonConstants";
import { planTypes } from "utils/Types";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  borderRadius: "8px",
  height: "100%",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
    boxShadow: "0px 0px 4px rgba(19, 41, 138, 0.1), 0px 10px 25px rgba(19, 41, 138, 0.1)"
  },

  "&:focus": {
    backgroundColor: tokens.Background.General.Primary,
    border: `2px solid ${tokens.Border.General.LightColor}`
  },
  "&:active": {
    backgroundColor: tokens.Background.General.Primary
  },
  "&:disabled": {
    backgroundColor: tokens.Background.General.Secondary
  }
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center"
}));

interface Props {
  divider?: boolean;
  getInputDetails?: (prop: string) => void;
  value?: string;
  placeholder?: string;
  planType?: string;
  sx?: {};
}

export default function SearchAppBar(props: Props) {
  const { getInputDetails, value = "", placeholder = "Search by name", planType = "", sx } = props;
  const [inputText, setInputText] = React.useState(value);
  const { isMobileScreen } = useContext(ThemeContext);
  const dispatch = useAppDispatch();
  const onChange = (event: any) => {
    if (planType === "filter") getInputDetails?.(event.target.value);
    setInputText(event.target.value);
  };

  return (
    <Box
      width={isMobileScreen ? "100%" : "auto"}
      sx={{
        borderRadius: "5px",
        height: "50px"
      }}
      id="SearchBar"
    >
      <Search
        sx={{
          backgroundColor: tokens.Background.General.Primary,
          paddingRight: "12px",
          ...sx
        }}
      >
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <InputBase
          sx={{ width: "100%", paddingLeft: "48px", fontWeight: "600" }}
          endAdornment={
            inputText ? (
              <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                <SearchCross
                  sx={{ fontSize: "20px" }}
                  onClick={() => {
                    setInputText("");
                    dispatch(setSearchActive(false));
                    getInputDetails?.("");
                    dispatch(setSearchText(""));
                  }}
                />
              </Box>
            ) : (
              ""
            )
          }
          onChange={onChange}
          placeholder={placeholder}
          value={inputText}
          inputProps={{
            "aria-label": "search",
            onKeyPress: (event) => {
              if (event.key === "Enter") {
                if (inputText && planType === planTypes.AllPlans) dispatch(setSearchActive(true));
                if (!inputText && planType === planTypes.AllPlans) dispatch(setSearchActive(false));
                getInputDetails?.(inputText);
                if (inputText.length > minSearchStrLength || !inputText) dispatch(setSearchText(inputText));
                event.preventDefault();
              }
            }
          }}
        />
      </Search>
    </Box>
  );
}
